export default "__VITE_ASSET__Bqf3lyjm__"